import {IState} from 'angular-ui-router';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import BenutzerRS from '../core/service/BenutzerRS.rest';

zahlungenRun.$inject = ['RouterHelper'];

/* @ngInject */
export function zahlungenRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'zahlungen',
            template: '<zahlungen-view flex="auto" class="overflow-scroll" besitzer="$resolve.besitzer"></zahlungen-view>',
            url: '/zahlungen',
            resolve: {
                besitzer: getPossibleBesitzer
            }
        },

    ];
}

getPossibleBesitzer.$inject = ['BenutzerRS'];
/* @ngInject */
export function getPossibleBesitzer(benutzerRS: BenutzerRS) {
    return benutzerRS.possibleZahlungsauftragBesitzer();
}




// WEBPACK FOOTER //
// ./src/app/zahlungen/zahlungen.route.ts